import * as actionTypes from "../actions/actionTypes";

const initialState = [];

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_CALENDAR:
      console.log(action);
      return action.calendars;
    default:
      return state;
  }
};

export default reducer;
